
        import {css} from 'lit-element';   
        export default css`/*! RESET ANY INHERITED CSS  */

:host #icon-bridge-widget-wrapper {
    all: initial;
}

:host #icon-bridge-widget-wrapper {
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #49546a;
    font-size: 16px;
    font-weight: normal;
    font-family: montserrat-regular !important;
    line-height: 1.4;
    min-height: 100%;
    background-image: -moz-linear-gradient( 135deg, rgb(213,221,241) 0%, rgb(241,244,249) 100%);
    background-image: -webkit-linear-gradient( 135deg, rgb(213,221,241) 0%, rgb(241,244,249) 100%);
    background-image: -ms-linear-gradient( 135deg, rgb(213,221,241) 0%, rgb(241,244,249) 100%);
    background-image: -webkit-linear-gradient( 135deg, rgb(213,221,241) 0%, rgb(241,244,249) 100%);
}
.grid-cell {
    flex-direction: row;
    display: flex;
    max-width: 80vw;
}

.label-small {
    font-size: 28px;
    color: rgba(73, 84, 106, 0.75);
    line-height: 1.6;
}

@media (max-width: 600px) {
    .grid-cell {
        flex-direction: column;
        max-width: 80%;
    }
    .label-small {
        font-size: 15px;
    }
}

@media (min-width: 2000px) {
    .label-small {
        font-size: 35px;
    }
}

.logo {
    max-width: 50vw;
    height: auto;
}


/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

/* Document
   ========================================================================== */

/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */

html {
    line-height: 1.15; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
   ========================================================================== */

/**
 * Remove the margin in all browsers.
 */

body {
    margin: 0;
}

/**
 * Render the main element consistently in IE.
 */

main {
    display: block;
}

/**
 * Correct the font size and margin on h1 elements within section and
 * article contexts in Chrome, Firefox, and Safari.
 */
h1 {
    font-size: 2em;
    margin: 0.67em 0;
}

/* Grouping content
   ========================================================================== */

/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */

hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd em font sizing in all browsers.
 */

pre {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
}

/* Text-level semantics
   ========================================================================== */

/**
 * Remove the gray background on active links in IE 10.
 */

a {
    background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */

abbr[title] {
    border-bottom: none; /* 1 */
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */

b,
strong {
    font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd em font sizing in all browsers.
 */

code,
kbd,
samp {
    font-family: monospace, monospace; /* 1 */
    font-size: 1em; /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */

small {
    font-size: 80%;
}

/**
 * Prevent sub and sup elements from affecting the line height in
 * all browsers.
 */

sub,
sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
}

sub {
    bottom: -0.25em;
}

sup {
    top: -0.5em;
}

/* Embedded content
   ========================================================================== */

/**
 * Remove the border on images inside links in IE 10.
 */

img {
    border-style: none;
}

/* Forms
   ========================================================================== */

/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */

button,
input,
optgroup,
select,
textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0; /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

button,
input { /* 1 */
    overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */

button,
select { /* 1 */
    text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */

button,
[type="button"],
[type="reset"],
[type="submit"] {
    -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
    outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */

fieldset {
    padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from fieldset elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    fieldset elements in all browsers.
 */

legend {
    box-sizing: border-box; /* 1 */
    color: inherit; /* 2 */
    display: table; /* 1 */
    max-width: 100%; /* 1 */
    padding: 0; /* 3 */
    white-space: normal; /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */

progress {
    vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */

textarea {
    overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */

[type="checkbox"],
[type="radio"] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
    height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */

[type="search"] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */

[type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to inherit in Safari.
 */

::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
}

/* Interactive
   ========================================================================== */

/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */

details {
    display: block;
}

/*
 * Add the correct display in all browsers.
 */

summary {
    display: list-item;
}

/* Misc
   ========================================================================== */

/**
 * Add the correct display in IE 10+.
 */

template {
    display: none;
}

/**
 * Add the correct display in IE 10.
 */

[hidden] {
    display: none;
}


/* ==========================================================================
	HTML
========================================================================== */

/*
*	Force border box
*/

*, *::after, *::before {
    box-sizing: border-box;
}

/*
*	Base styles
*/



body {
    margin-left: auto;
    margin-right: auto;
    background-size: contain;
    background-repeat: no-repeat;
    max-width: 1600px;
}
main {
    margin: 0 auto;
}
h1 {
    font-size: 55px;
    margin: 0;
    font-family: montserrat-semibold;
    font-weight: normal;
    line-height: 1.2;
}
h2 {
    font-size: 25px;
    margin: 0;
    font-family: montserrat-semibold;
    font-weight: normal;
}
h2 {
    font-family: montserrat-semibold;
    font-weight: normal;
}
p {
    margin: 0;
    line-height: 1.4;
    font-family: montserrat-regular
}
a {
    text-decoration: none;
    color: #1fb4b7;
    cursor: pointer !important;
    transition: color 0.3s ease;
}
a:hover {
    color: #159093;
    transition: color 0.2s ease;
}
section {
    margin: 100px 0px;
}
input {
    border-radius: 100px;
    border: 2px solid #ced9e3;
    padding: 8px 20px;
    color: #49546a;
    outline: none;
    transition: border 0.2s ease;
}
.square-input input,
.square-input select {
    border-radius: 10px;
}
input:focus,
input:hover {
    border: 2px solid #22cabe;
    transition: border 0.2s ease;
}
input[type="file"] {
    width: 100%;
    border: none;
    background-color: #e0e6f2;
}
select {
    width: 100%;
    border-radius: 100px;
    border: 2px solid #ced9e3;
    padding: 8px 20px;
    color: #49546a;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
    transition: border 0.2s ease;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEwIDciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoyOyI+CiAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwxLC0zNzg1LjYzLC04NTcuNzU5KSI+CiAgICAgICAgPHBhdGggZD0iTTM3OTAuNSw4NjQuMjU5TDM3ODUuNjMsODU3Ljc1OUwzNzk1LjM4LDg1Ny43NTlMMzc5MC41LDg2NC4yNTlaIiBzdHlsZT0iZmlsbDpyZ2IoMTk5LDIxNywyMzQpOyIvPgogICAgPC9nPgo8L3N2Zz4K);
    background-size: 12px;
    background-repeat: no-repeat;
    background-position: right 10px center;
}
select:focus,
select:hover {
    border: 2px solid #22cabe;
    transition: border 0.2s ease;
}

/*
*	Selection
*/

::-moz-selection {
    background: #b3d4fc;
    text-shadow: none;
}
::selection {
    background: #b3d4fc;
    text-shadow: none;
}

/*
*	Scrollbars
*/

::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
}

.widget {
    scrollbar-width: none;
}

/*
*	Misc
*/

hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 1em 0;
    padding: 0;
}
audio,
canvas,
iframe,
img,
svg,
video {
    vertical-align: middle;
}
fieldset {
    border: 0;
    margin: 0;
    padding: 0;
}
textarea {
    resize: vertical;
}

/* ==========================================================================
	Header
========================================================================== */

header {
    padding-top: 50px;
    padding-bottom: 25px;
}
header .logo {
    display: block;
    width: 135px;
    margin: auto;
}
header nav ul {
    list-style: none;
    text-align: right;
}
header nav ul li {
    display: inline-block;
    margin-right: 25px;
}
header nav ul li:last-of-type {
    margin-right: 0;
}

/* ==========================================================================
	Footer
========================================================================== */

footer {
    margin-top: 50px;
    margin-bottom: 50px;
}

/* ==========================================================================
	Grids
========================================================================== */

/*
*
* 3.1 - Grids & layout
*
*/

/* Grid setup */

.grid {
    display: flex;
}


/* Grid alignment */

.grid-top {
    align-items: flex-start;
}
.grid-bottom {
    align-items: flex-end;
}
.grid-center {
    align-items: center;
}

/* Grid sizes */

/* Grid vertical */

.grid.grid-vertical {
    flex-direction: column;
}

/* ==========================================================================
	Modules
========================================================================== */

/*
*	Buttons
*/

.p-30 {
    padding: 30px;
}

.conclusion-text-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.conclusion-text-container .link {
    font-size: larger;
    font-weight: bold;
}

.button {
	display: inline-block;
	border-radius: 100px;
	padding: 10px 30px;
	min-width: 150px;
	text-align: center;
	color: #ffffff;
	background-size: 1px 200px;
	background-color: #2196F3; /* fallback */
	box-shadow: 0 2.8px 2.2px rgba(30, 128, 177, 0.017), 0 6.7px 5.3px rgba(30, 128, 177, 0.024), 0 12.5px 10px rgba(30, 128, 177, 0.03), 0 22.3px 17.9px rgba(30, 128, 177, 0.036), 0 41.8px 33.4px rgba(30, 128, 177, 0.043), 0 100px 80px rgba(30, 128, 177, 0.06);
	background-image: linear-gradient( -135deg, rgb(34,215,194) 0%, rgb(30,158,177) 100%);
	background-image: -moz-linear-gradient( -135deg, rgb(34,215,194) 0%, rgb(30,158,177) 100%);
	background-image: -webkit-linear-gradient( -135deg, rgb(34,215,194) 0%, rgb(30,158,177) 100%);
	background-image: -ms-linear-gradient( -135deg, rgb(34,215,194) 0%, rgb(30,158,177) 100%);
	transition: box-shadow 0.3s ease, background-position 0.3s ease;
    cursor: pointer !important;
}
.button:hover {
    color: #ffffff;
    border: none !important;
    box-shadow: 0 2.8px 2.2px rgba(30, 128, 177, 0.034), 0 6.7px 5.3px rgba(30, 128, 177, 0.048), 0 12.5px 10px rgba(30, 128, 177, 0.06), 0 22.3px 17.9px rgba(30, 128, 177, 0.072), 0 41.8px 33.4px rgba(30, 128, 177, 0.086), 0 100px 80px rgba(30, 128, 177, 0.12);
    background-position: 50px;
    transition: box-shadow 0.2s ease, background-position 0.2s ease;
}
.button.outline {
    border: 2px solid #1fb4b7;
    color: #1fb4b7;
    background-image: none;
    background-color: transparent;
    padding: 8px 30px;
    box-shadow: transparent;
    transition: color 0.3s ease, border 0.3s ease, background-color 0.3s ease;
}
.button.outline:hover {
    color: #ffffff;
    background-color: #1fb4b7;
    transition: color 0.2s ease, border 0.2s ease, background-color 0.2s ease;
}
.button.inactive {
    color: #49546a;
    background-image: none;
    background-color: #e0e6f2;
    padding: 8px 30px;
    box-shadow: none;
    cursor: not-allowed !important;
}
.button span.bridge-logo {
    background-image: url(data:image/png;base64,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);
    width: 25px;
    height: 35px;
    position: absolute;
    background-size: 20px;
    background-repeat: no-repeat;
    margin-left: -30px;
    margin-top: -2px;
}
.button.bridge-button {
    margin: auto;
    padding-left: 60px;
}

/*
*	Tables
*/

.transaction-list {
    width: 100%;
    border-collapse: collapse;
}
.transaction-list .date {
    font-family: montserrat-semibold;
    font-weight: normal;
}
.transaction-list .date::after {
    content: '';
    display: block;
    height: 1px;
    width: 100%;
    margin-top: 10px;
    background-color: #ced9e3;
}
.transaction-list tbody tr.deposited:hover td,
.transaction-list tbody tr.sent:hover td,
.transaction-list tbody tr.withdrawing:hover td,
.transaction-list tbody tr.withdrawn:hover td  {
    background-color: #dbe3f0;
    padding-left: 15px !important;
    padding-right: 15px !important;
    cursor: pointer;
    transition: background-color 0.2s ease, padding 0.2s ease;
}
.transaction-list tbody tr.withdrawing td {
    color: rgba(73, 84, 106, 0.75);
}
.transaction-list td {
    padding-top: 10px;
    padding-bottom: 10px;
    transition: background-color 0.3s ease, padding 0.3s ease;
}
.transaction-list td.date {
    padding-top: 20px;
}
.transaction-list td.date {
    padding-top: 25px;
    padding-bottom: 5px;
}
.transaction-list .deposited td:last-of-type {
    color: #1fb4b7;
}
.transaction-list .deposited td:first-of-type::before,
.transaction-list .sent td:first-of-type::before,
.transaction-list .withdrawing td:first-of-type::before,
.transaction-list .withdrawn td:first-of-type::before {
    position: relative;
    display: inline-block;
    width: 25px;
    margin-right: 10px;
    margin-top: -6px;
    transform: translate(0px, 6px);
}
.transaction-list .deposited td:first-of-type::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIyIDIyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTEsLTEpIj4KICAgICAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6cmdiKDMxLDE4MCwxODMpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICAgICAgPHBhdGggZD0iTTgsMTJMMTIsMTZMMTYsMTIiIHN0eWxlPSJmaWxsOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOnJnYigzMSwxODAsMTgzKTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMiw4TDEyLDE2IiBzdHlsZT0iZmlsbDpub25lO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpyZ2IoMzEsMTgwLDE4Myk7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgIDwvZz4KPC9zdmc+Cg==);
}
.transaction-list .sent td:first-of-type::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIyIDIyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTEsLTEpIj4KICAgICAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwtMSwwLDI0KSI+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEwIiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTpyZ2IoODksMTAwLDEyMCk7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgICAgICA8L2c+CiAgICA8L2c+CiAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwxLC0xLC0xKSI+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsLTEsMCwyNCkiPgogICAgICAgICAgICA8cGF0aCBkPSJNOCwxMkwxMiwxNkwxNiwxMiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDg5LDEwMCwxMjApO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwtMSwtMSkiPgogICAgICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLC0xLDAsMjQpIj4KICAgICAgICAgICAgPHBhdGggZD0iTTEyLDhMMTIsMTYiIHN0eWxlPSJmaWxsOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOnJnYig4OSwxMDAsMTIwKTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==);
}
.transaction-list .withdrawing td:first-of-type::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIyIDIyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTEsLTEpIj4KICAgICAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6cmdiKDg5LDEwMCwxMjApO3N0cm9rZS1vcGFjaXR5OjAuNzU7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgICAgICA8cGF0aCBkPSJNMTIsNkwxMiwxMkwxNiwxNCIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDg5LDEwMCwxMjApO3N0cm9rZS1vcGFjaXR5OjAuNzU7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgIDwvZz4KPC9zdmc+Cg==);
}
.transaction-list .withdrawn td:first-of-type::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIyIDIyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTEsLTEpIj4KICAgICAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwtMSwwLDI0KSI+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEwIiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTpyZ2IoODksMTAwLDEyMCk7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgICAgICA8L2c+CiAgICA8L2c+CiAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwxLC0xLC0xKSI+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsLTEsMCwyNCkiPgogICAgICAgICAgICA8cGF0aCBkPSJNOCwxMkwxMiwxNkwxNiwxMiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDg5LDEwMCwxMjApO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwtMSwtMSkiPgogICAgICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLC0xLDAsMjQpIj4KICAgICAgICAgICAgPHBhdGggZD0iTTEyLDhMMTIsMTYiIHN0eWxlPSJmaWxsOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOnJnYig4OSwxMDAsMTIwKTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==);
}
.transaction-list tr td:last-of-type {
    text-align: right;
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
}
.transaction-list tr td:first-of-type {
    text-align: initial;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
}
.transaction-list .deposited td:last-of-type::after,
.transaction-list .sent td:last-of-type::after,
.transaction-list .withdrawing td:last-of-type::after,
.transaction-list .withdrawn td:last-of-type::after {
    position: relative;
    display: inline-block;
    width: 6px;
    margin-top: 2px;
    margin-left: 10px;
}
.transaction-list .deposited td:last-of-type::after {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDggMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDsiPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwtOCwtNSkiPgogICAgICAgIDxwYXRoIGQ9Ik05LDE4TDE1LDEyTDksNiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDMxLDE4MCwxODMpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=);
}
.transaction-list .sent td:last-of-type::after {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDggMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDsiPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwtOCwtNSkiPgogICAgICAgIDxwYXRoIGQ9Ik05LDE4TDE1LDEyTDksNiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDkwLDEwMSwxMjEpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=);
}
.transaction-list .withdrawing td:last-of-type::after {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDggMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDsiPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwtOCwtNSkiPgogICAgICAgIDxwYXRoIGQ9Ik05LDE4TDE1LDEyTDksNiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDkwLDEwMSwxMjEpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=);
}
.transaction-list .withdrawn td:last-of-type::after {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDggMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDsiPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwtOCwtNSkiPgogICAgICAgIDxwYXRoIGQ9Ik05LDE4TDE1LDEyTDksNiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDkwLDEwMSwxMjEpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=);
}

/*
*	Assets list
*/

.assets-list {
    width: 100%;
    border-collapse: collapse;
}
.assets-list .title {
    font-family: montserrat-semibold;
    font-weight: normal;
}
.assets-list .title::after {
    content: '';
    display: block;
    height: 1px;
    width: 100%;
    margin-top: 10px;
    background-color: #ced9e3;
}
.assets-list tbody tr.asset:hover td {
    background-color: #dbe3f0;
    cursor: pointer;
    transition: background-color 0.2s ease, padding 0.2s ease;
}
.assets-list td {
    padding-top: 10px;
    padding-bottom: 10px;
    transition: background-color 0.3s ease, padding 0.3s ease;
}
.assets-list td.title {
    padding-top: 20px;
}
.assets-list td.title {
    padding-top: 25px;
    padding-bottom: 5px;
}
.assets-list .card td:last-of-type {
    color: #1fb4b7;
}
.assets-list .card td:first-of-type::before,
.assets-list .bank td:first-of-type::before {
    position: absolute;
    display: inline-block;
    width: 25px;
    margin-right: 10px;
    margin-top: -6px;
    transform: translate(0px, 6px);
}
.assets-list img {
    display: block;
    height: 40px;
    margin: 0 auto;
}
.assets-list tbody tr.asset td:last-of-type {
    padding-right: 15px;
}
.assets-list tr td:last-of-type {
    text-align: right;
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
}
.assets-list tr td:first-of-type {
    text-align: initial;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
}
.assets-list td.title::after {
    content: '';
    display: block;
    height: 1px;
    width: 100%;
    margin-top: 10px;
    background-color: #ced9e3;
}

/*
*	Payments list
*/

.payments-list {
    width: 100%;
    border-collapse: collapse;
}
.payments-list .title {
    font-family: montserrat-semibold;
    font-weight: normal;
}
.payments-list .title::after {
    content: '';
    display: block;
    height: 1px;
    width: 100%;
    margin-top: 10px;
    background-color: #ced9e3;
}
.payments-list tbody tr.card:hover td,
.payments-list tbody tr.bank:hover td  {
    background-color: #dbe3f0;
    cursor: pointer;
    transition: background-color 0.2s ease, padding 0.2s ease;
}
.payments-list .text-red  {
    text-align: center;
    display: block;
    margin-right: 15px;
}
.payments-list td {
    padding-top: 10px;
    padding-bottom: 10px;
    transition: background-color 0.3s ease, padding 0.3s ease;
}
.payments-list td.title {
    padding-top: 20px;
}
.payments-list td.title {
    padding-top: 25px;
    padding-bottom: 5px;
}
.payments-list .card td:last-of-type {
    color: #1fb4b7;
}
.payments-list .card td:first-of-type::before,
.payments-list .bank td:first-of-type::before {
    position: absolute;
    display: inline-block;
    width: 25px;
    margin-right: 10px;
    margin-top: -6px;
    transform: translate(0px, 6px);
}
.payments-list .card img,
.payments-list .bank img {
    width: 50px;
    margin-left: 20px;
}
.payments-list tr td:last-of-type {
    text-align: right;
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
}
.payments-list tr td:first-of-type {
    text-align: initial;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
}
.payments-list .card td:last-of-type::after,
.payments-list .bank td:last-of-type::after {
    position: relative;
    display: inline-block;
    width: 6px;
    margin-top: 2px;
    margin-left: 10px;
}
.payments-list .animation-underline:after {
    position: relative;
}
.payments-list .animation-underline.text-red:hover {
    cursor: pointer;
}
.payments-list .animation-underline.text-red:hover:after {
    background: #F42055;
}



.fee-list {
    width: 100%;
    border-collapse: collapse;
}
.fee-list th {
    text-align: left;
    font-weight: normal;
    padding-bottom: 10px;
}
.fee-list tbody tr td {
    font-size: 14px;
    padding-bottom: 10px;
}
.fee-list tbody tr:last-of-type td {
    padding-top: 10px;
    font-size: inherit;
}

/*
*	Text alignment
*/

.text-left {
    text-align: left !important;
}
.text-right {
    text-align: right;
}
.text-center {
    text-align: center;
}

/*
*	Text Weight
*/

.text-bold {
    font-family: montserrat-semibold;
    font-weight: normal;
}
.text-upper {
    text-transform: uppercase;
}

/*
*	Text colour
*/

.text-green {
    color: #1fb4b7;
}
.text-red {
    color: #F42055;
}

/*
*	Text small
*/

.text-small {
    font-size: 14px;
}

/*
*	Opacity
*/

.opacity-75 {
    opacity: 0.75;
}

/*
*	Element alignment
*/

.align-left {
    margin-right: auto;
}
.align-right {
    margin-left: auto;
}
.align-center {
    margin-left: auto;
    margin-right: auto;
}

/*
*	Arrows
*/

.arrow-send::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIyIDIyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTEsLTEpIj4KICAgICAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwtMSwwLDI0KSI+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEwIiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTpyZ2IoODksMTAwLDEyMCk7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgICAgICA8L2c+CiAgICA8L2c+CiAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwxLC0xLC0xKSI+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsLTEsMCwyNCkiPgogICAgICAgICAgICA8cGF0aCBkPSJNOCwxMkwxMiwxNkwxNiwxMiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDg5LDEwMCwxMjApO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwtMSwtMSkiPgogICAgICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLC0xLDAsMjQpIj4KICAgICAgICAgICAgPHBhdGggZD0iTTEyLDhMMTIsMTYiIHN0eWxlPSJmaWxsOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOnJnYig4OSwxMDAsMTIwKTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==);
    position: relative;
    display: inline-block;
    width: 25px;
    margin-right: 10px;
    margin-top: -6px;
    transform: translate(0px, 6px);
}
.arrow-receive::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIyIDIyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTEsLTEpIj4KICAgICAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6cmdiKDMxLDE4MCwxODMpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICAgICAgPHBhdGggZD0iTTgsMTJMMTIsMTZMMTYsMTIiIHN0eWxlPSJmaWxsOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOnJnYigzMSwxODAsMTgzKTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMiw4TDEyLDE2IiBzdHlsZT0iZmlsbDpub25lO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpyZ2IoMzEsMTgwLDE4Myk7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgIDwvZz4KPC9zdmc+Cg==);
    position: relative;
    display: inline-block;
    width: 25px;
    margin-right: 10px;
    margin-top: -6px;
    transform: translate(0px, 6px);
}

/*
*	Form elements
*/

input[type="number"] {
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    appearance: textfield;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
}

/*
*	Hidden
*/

.visually-hidden {
    z-index: -999;
    position: absolute;
    opacity: 0;
}

/*
*	Animation
*/

.animation-underline:after {
    content: '';
    display: block;
    position: absolute;
    width: 0px;
    height: 2px;
    margin-top: 3px;
    background: transparent;
    border-radius: 3px;
    transition: width 0.3s ease, background-color 0.3s ease;
}
.animation-underline:hover:after {
    width: 100%;
    background: #1fb4b7;
}
.animation-underline.active:after {
    width: 100%;
    background: #1fb4b7;
}

/*
*	Labels
*/

.label-outline {
    padding: 2px 10px;
    color: #20c1bb;
    border: 2px solid #20c1bb;
    border-radius: 15px;
}
.label-upper {
    text-transform: uppercase;
    letter-spacing: 3px;
    font-size: 14px;
}
/*
*	Currency
*/

.currency {
    margin-left: 5px;
}

/*
*	Or
*/

.or {
    max-width: 75px;
}
.or span {
    color: rgba(73, 84, 106, 0.75);
    background-color: #f1f4f9;
    z-index: 9;
    position: relative;
    padding: 10px 0;
}
.or::after {
    content: '';
    display: block;
    position: absolute;
    width: 1px;
    height: 85px;
    left: 50%;
    background-color: #ced9e3;
    margin-top: -55px;
}


/*
*	Borders
*/
.border-left {
    border-left: 1px solid #ced9e3;
}
.border-right {
    border-right: 1px solid #ced9e3;
}
.border-top {
    border-top: 1px solid #ced9e3;
}
.border-bottom {
    border-bottom: 1px solid #ced9e3;
}

/*
*	Sizing
*/

.inherit-height {
    min-height: inherit;
}

/*
*	Margins
*/

.no-margin {
	margin: 0 !important;
}
.margin-top-0 {
	margin-top: 0 !important;
}
.margin-top-5 {
	margin-top: 5px !important;
}
.margin-top-10 {
	margin-top: 10px !important;
}
.margin-top-15 {
	margin-top: 15px !important;
}
.margin-top-25 {
	margin-top: 25px !important;
}
.margin-top-35 {
	margin-top: 35px !important;
}
.margin-bottom-0 {
	margin-bottom: 0 !important;
}
.margin-bottom-5 {
	margin-bottom: 5px !important;
}
.margin-bottom-10 {
	margin-bottom: 10px !important;
}
.margin-bottom-15 {
	margin-bottom: 15px !important;
}
.margin-bottom-20 {
	margin-bottom: 20px !important;
}
.margin-bottom-25 {
	margin-bottom: 25px !important;
}
.margin-bottom-35 {
	margin-bottom: 35px !important;
}
.margin-right-25 {
	margin-right: 25px !important;
}
.margin-right-35 {
	margin-right: 35px !important;
}


/*
*	Padding
*/

.no-padding {
	padding: 0 !important;
}
.padding-top-0 {
	padding-top: 0 !important;
}
.padding-top-5 {
	padding-top: 5px !important;
}
.padding-top-15 {
	padding-top: 15px !important;
}
.padding-top-25 {
	padding-top: 25px !important;
}
.padding-top-35 {
	padding-top: 35px !important;
}
.padding-bottom-0 {
	padding-bottom: 0 !important;
}
.padding-bottom-5 {
	padding-bottom: 5px !important;
}
.padding-bottom-15 {
	padding-bottom: 15px !important;
}
.padding-bottom-25 {
	padding-bottom: 25px !important;
}
.padding-bottom-35 {
	padding-bottom: 35px !important;
}

/* ==========================================================================
	Widget
========================================================================== */

.widget {
    position: relative;
    background-image: url(data:image/png;base64,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) !important;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: #f1f4f9;
    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
    max-width: 430px;
    min-height: 420px;
    max-height: 500px;
    padding: 35px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 40px;
    box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.017), 0 6.7px 5.3px rgba(0, 0, 0, 0.024), 0 12.5px 10px rgba(0, 0, 0, 0.03), 0 22.3px 17.9px rgba(0, 0, 0, 0.036), 0 41.8px 33.4px rgba(0, 0, 0, 0.043), 0 100px 80px rgba(0, 0, 0, 0.06);
}
.widget .logo {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 50px;
}
.widget h1,
.widget h2 {
	text-align: center;
}
.widget h2 {
	font-size: 30px;
}
.widget input[type=number],
.widget input[type=text],
.widget input[type=email] {
	width: 100%;
}
.widget .feature-icon {
	display: block;
	max-width: 60px;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 15px;
}
.widget .edit::before {
	content: url(data:image/svg+xml;base64,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);
	position: relative;
	width: 24px;
	margin-top: 2px;
	margin-left: 10px;
	float: right;
	transition: width ease 0.3s, padding ease 0.3s;
}
.widget .back::before {
	content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDggMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDsiPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEsMCwwLDEsMTYsLTUpIj4KICAgICAgICA8cGF0aCBkPSJNOSwxOEwxNSwxMkw5LDYiIHN0eWxlPSJmaWxsOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOnJnYigzMSwxODAsMTgzKTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgPC9nPgo8L3N2Zz4K);
	position: relative;
	width: 18px;
	margin-top: 1px;
	padding-right: 10px;
	float: left;
	transition: width ease 0.3s, padding ease 0.3s;
}
.widget .back:hover::before {
	width: 23px;
	padding-right: 15px;
	transition: width ease 0.2s, padding ease 0.2s;
}
.widget .or-horizontal {
	text-align: center;
}
.widget .or-horizontal::after {
	content: '';
	display: block;
	width: 100%;
	height: 1px;
	background-color: #ced9e3;
	margin-top: -13px;
}
.widget .or-horizontal span {
	padding: 0 15px;
	background-color: #eff2f8;
}
.widget .feature-inline .grid-cell:first-of-type {
	max-width: 85px;
}
.widget .feature-inline {
	min-width: 300px;
}
.widget .feature-inline img {
	max-width: 60px;
}

/* ==========================================================================
	Menu
========================================================================== */

.tooltip {
	display: block;
	position: relative;
	z-index: 999;
}

/* Gap filler */

.tooltip-item::after {
    content: '';
    position: absolute;
    width: 360px;
    height: 20px;
    bottom: 100%;
    left: 50%;
    pointer-events: none;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
}

.tooltip:hover .tooltip-item::after {
	pointer-events: auto;
}

/* Tooltip */

.tooltip-content {
    position: absolute;
    z-index: 9999;
    width: 100%;
    bottom: 100%;
    padding: 35px;
    text-align: left;
    font-size: 14px;
    box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.017), 0 6.7px 5.3px rgba(0, 0, 0, 0.024), 0 12.5px 10px rgba(0, 0, 0, 0.03), 0 22.3px 17.9px rgba(0, 0, 0, 0.036), 0 41.8px 33.4px rgba(0, 0, 0, 0.043), 0 100px 80px rgba(0, 0, 0, 0.06);
    background: #edf0f7;
    opacity: 0;
    cursor: default;
    pointer-events: none;
    border-radius: 20px;
    top: 35px;
    min-height: 350px;
}
.tooltip .tooltip-content {
    -webkit-transform: translate3d(0,-10px,0) rotate3d(1,1,0,25deg);
    transform: translate3d(0,-10px,0) rotate3d(1,1,0,25deg);
    -webkit-transition: opacity 0.3s, -webkit-transform 0.3s;
    transition: opacity 0.3s, transform 0.3s;
}
.tooltip .tooltip-content.active {
    pointer-events: auto;
    opacity: 1;
    -webkit-transform: translate3d(0,0,0) rotate3d(0,0,0,0);
    transform: translate3d(0,0,0) rotate3d(0,0,0,0);
}

.tooltip .tooltip-content .menu-list {
    padding: 0;
    list-style-type: none;
}
.tooltip .tooltip-content .menu-list li {
	margin-top: 10px;
	margin-bottom: 10px;
	padding-top: 10px;
	padding-bottom: 10px;
	border-radius: 25px;
	cursor: pointer;
	transition: background-color 0.3s ease, padding 0.3s ease;
}
.tooltip .tooltip-content .menu-list li a {
	color: #49546a;
}
.tooltip .tooltip-content .menu-list li:not(.disable):hover {
	background-color: #dbe3f0;
	padding-left: 15px !important;
	padding-right: 15px !important;
	transition: background-color 0.2s ease, padding 0.2s ease;
}
.tooltip .tooltip-content .menu-list .disable {
    cursor: not-allowed;
}
.tooltip .tooltip-content .menu-list li::before {
	position: relative;
	display: inline-block;
	width: 25px;
	margin-right: 15px;
	margin-top: -5px;
	transform: translate(0px, 6px);
}
.tooltip .tooltip-content .menu-list li:first-of-type::before {
	content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIyIDE4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTEsLTMpIj4KICAgICAgICA8cGF0aCBkPSJNNCw0TDIwLDRDMjEuMSw0IDIyLDQuOSAyMiw2TDIyLDE4QzIyLDE5LjEgMjEuMSwyMCAyMCwyMEw0LDIwQzIuOSwyMCAyLDE5LjEgMiwxOEwyLDZDMiw0LjkgMi45LDQgNCw0WiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDczLDg0LDEwNik7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgICAgICA8cGF0aCBkPSJNMjIsNkwxMiwxM0wyLDYiIHN0eWxlPSJmaWxsOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOnJnYig3Myw4NCwxMDYpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=);
}
.tooltip .tooltip-content .menu-list li.blockchain::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIwIDIzIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTIsLTEuMDAyMzgpIj4KICAgICAgICA8cGF0aCBkPSJNMjEsMTZMMjEsOEMyMC45OTksNy4yODcgMjAuNjE3LDYuNjI2IDIwLDYuMjdMMTMsMi4yN0MxMi4zODIsMS45MTMgMTEuNjE4LDEuOTEzIDExLDIuMjdMNCw2LjI3QzMuMzgzLDYuNjI2IDMuMDAxLDcuMjg3IDMsOEwzLDE2QzMuMDAxLDE2LjcxMyAzLjM4MywxNy4zNzQgNCwxNy43M0wxMSwyMS43M0MxMS42MTgsMjIuMDg3IDEyLjM4MiwyMi4wODcgMTMsMjEuNzNMMjAsMTcuNzNDMjAuNjE3LDE3LjM3NCAyMC45OTksMTYuNzEzIDIxLDE2WiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDczLDg0LDEwNik7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgICAgICA8cGF0aCBkPSJNMy4yNyw2Ljk2TDEyLDEyLjAxTDIwLjczLDYuOTYiIHN0eWxlPSJmaWxsOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOnJnYig3Myw4NCwxMDYpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICAgICAgPHBhdGggZD0iTTEyLDIyLjA4TDEyLDEyIiBzdHlsZT0iZmlsbDpub25lO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpyZ2IoNzMsODQsMTA2KTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgPC9nPgo8L3N2Zz4K);
    margin-top: -5px;
    width: 23px;
}
.tooltip .tooltip-content .menu-list li:last-of-type::before {
	content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDE0IDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTUsMCkiPgogICAgICAgIDxwYXRoIGQ9Ik0xMiwxTDEyLDIzIiBzdHlsZT0iZmlsbDpub25lO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpyZ2IoNzMsODQsMTA2KTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgICAgIDxwYXRoIGQ9Ik0xNyw1TDkuNSw1QzcuNTgsNSA2LDYuNTggNiw4LjVDNiwxMC40MiA3LjU4LDEyIDkuNSwxMkwxNC41LDEyQzE2LjQyLDEyIDE4LDEzLjU4IDE4LDE1LjVDMTgsMTcuNDIgMTYuNDIsMTkgMTQuNSwxOUw2LDE5IiBzdHlsZT0iZmlsbDpub25lO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpyZ2IoNzMsODQsMTA2KTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgPC9nPgo8L3N2Zz4K);
	width: 15px;
	margin-left: 5px;
	margin-right: 21px;
}
.tooltip .tooltip-content .menu-list li::after {
	content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDggMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDsiPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwtOCwtNSkiPgogICAgICAgIDxwYXRoIGQ9Ik05LDE4TDE1LDEyTDksNiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDkwLDEwMSwxMjEpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=);
	position: relative;
	width: 6px;
	margin-top: 6px;
	margin-left: 10px;
	float: right;
}
.tooltip .tooltip-content .menu-list li:first-of-type::after {
	margin-top: 1px;
}
#menu-trigger {
	display: inline-block;
	position: relative;
}

#menu-tooltip {
    min-height: 380px;
    border-radius: 40px;
}

#menu-tooltip .verify-status .label-outline {
    transition: color 0.3s ease, background-color 0.3s ease;
}
#menu-tooltip .verify-status .label-outline:hover {
    background-color: #20c1bb;
    color: #ffffff;
    transition: color 0.2s ease, background-color 0.2s ease;
}

#menu-tooltip .verify-status.not-verified .label-outline {
    border: 2px solid #F42055;
    color: #F42055;
}
#menu-tooltip .verify-status.not-verified .label-outline:hover {
    background-color: #F42055;
    color: #ffffff;
    transition: color 0.2s ease, background-color 0.2s ease;
}

#menu-tooltip .verify-status.verifying .label-outline {
    border: 2px solid rgba(73, 84, 106, 0.75);
    color: rgba(73, 84, 106, 0.75);
}
#menu-tooltip .verify-status.verifying .label-outline:hover {
    background-color: rgba(73, 84, 106, 0.75);
    color: #ffffff;
    transition: color 0.2s ease, background-color 0.2s ease;
}

/* ==========================================================================
	Item list
========================================================================== */

.item-list {
    padding: 0;
    list-style-type: none;
    margin-bottom: 15px;
}
.item-list li {
    margin-top: 10px;
    margin-bottom: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 25px;
    cursor: pointer;
    transition: background-color 0.3s ease, padding 0.3s ease;
}
.item-list li a {
    color: #49546a;
}
.item-list li.verified a {
    color: #1fb4b7;
}
.item-list li.not-verified a {
    color: #F42055;
}
.item-list li:hover {
    background-color: #dbe3f0;
    padding-left: 15px !important;
    padding-right: 15px !important;
    transition: background-color 0.2s ease, padding 0.2s ease;
}
.item-list li::before {
    position: relative;
    display: inline-block;
    width: 25px;
    margin-right: 15px;
    margin-top: -5px;
    transform: translate(0px, 6px);
}
.item-list li.blockchain::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIwIDIzIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTIsLTEuMDAyMzgpIj4KICAgICAgICA8cGF0aCBkPSJNMjEsMTZMMjEsOEMyMC45OTksNy4yODcgMjAuNjE3LDYuNjI2IDIwLDYuMjdMMTMsMi4yN0MxMi4zODIsMS45MTMgMTEuNjE4LDEuOTEzIDExLDIuMjdMNCw2LjI3QzMuMzgzLDYuNjI2IDMuMDAxLDcuMjg3IDMsOEwzLDE2QzMuMDAxLDE2LjcxMyAzLjM4MywxNy4zNzQgNCwxNy43M0wxMSwyMS43M0MxMS42MTgsMjIuMDg3IDEyLjM4MiwyMi4wODcgMTMsMjEuNzNMMjAsMTcuNzNDMjAuNjE3LDE3LjM3NCAyMC45OTksMTYuNzEzIDIxLDE2WiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDczLDg0LDEwNik7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgICAgICA8cGF0aCBkPSJNMy4yNyw2Ljk2TDEyLDEyLjAxTDIwLjczLDYuOTYiIHN0eWxlPSJmaWxsOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOnJnYig3Myw4NCwxMDYpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICAgICAgPHBhdGggZD0iTTEyLDIyLjA4TDEyLDEyIiBzdHlsZT0iZmlsbDpub25lO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpyZ2IoNzMsODQsMTA2KTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgPC9nPgo8L3N2Zz4K);
    margin-top: -5px;
    width: 23px;
}
.item-list li.identity::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDE4IDIwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTMsLTIpIj4KICAgICAgICA8cGF0aCBkPSJNMjAsMjFMMjAsMTlDMjAsMTYuODA2IDE4LjE5NCwxNSAxNiwxNUw4LDE1QzUuODA2LDE1IDQsMTYuODA2IDQsMTlMNCwyMSIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDczLDg0LDEwNik7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgICAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjciIHI9IjQiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOnJnYig3Myw4NCwxMDYpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=);
    margin-top: -5px;
    width: 23px;
}
.item-list li.identity.verified::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDE4IDIwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTMsLTIpIj4KICAgICAgICA8cGF0aCBkPSJNMjAsMjFMMjAsMTlDMjAsMTYuODA2IDE4LjE5NCwxNSAxNiwxNUw4LDE1QzUuODA2LDE1IDQsMTYuODA2IDQsMTlMNCwyMSIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDMxLDE4MCwxODMpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+CiAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwxLC0zLC0yKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSI3IiByPSI0IiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTpyZ2IoMzEsMTgwLDE4Myk7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgIDwvZz4KPC9zdmc+Cg==);
    margin-top: -5px;
    width: 23px;
}
.item-list li.identity.not-verified::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDE4IDIwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTMsLTIpIj4KICAgICAgICA8cGF0aCBkPSJNMjAsMjFMMjAsMTlDMjAsMTYuODA2IDE4LjE5NCwxNSAxNiwxNUw4LDE1QzUuODA2LDE1IDQsMTYuODA2IDQsMTlMNCwyMSIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDI0NCwzMiw4NSk7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgIDwvZz4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTMsLTIpIj4KICAgICAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjciIHI9IjQiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOnJnYigyNDQsMzIsODUpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=);
    margin-top: -5px;
    width: 23px;
}
.item-list li.address::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIwIDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTIsMCkiPgogICAgICAgIDxwYXRoIGQ9Ik0yMSwxMEMyMSwxNyAxMiwyMyAxMiwyM0MxMiwyMyAzLDE3IDMsMTBDMyw1LjA2MyA3LjA2MywxIDEyLDFDMTYuOTM3LDEgMjEsNS4wNjMgMjEsMTBaIiBzdHlsZT0iZmlsbDpub25lO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpyZ2IoNzMsODQsMTA2KTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgICAgIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTAiIHI9IjMiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOnJnYig3Myw4NCwxMDYpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=);
    margin-top: -5px;
    width: 23px;
}
.item-list li.address.verified::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIwIDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTIsMCkiPgogICAgICAgIDxwYXRoIGQ9Ik0yMSwxMEMyMSwxNyAxMiwyMyAxMiwyM0MxMiwyMyAzLDE3IDMsMTBDMyw1LjA2MyA3LjA2MywxIDEyLDFDMTYuOTM3LDEgMjEsNS4wNjMgMjEsMTBaIiBzdHlsZT0iZmlsbDpub25lO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpyZ2IoMzEsMTgwLDE4Myk7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgIDwvZz4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTIsMCkiPgogICAgICAgIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTAiIHI9IjMiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOnJnYigzMSwxODAsMTgzKTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgPC9nPgo8L3N2Zz4K);
    margin-top: -5px;
    width: 23px;
}
.item-list li.address.not-verified::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIwIDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTIsMCkiPgogICAgICAgIDxwYXRoIGQ9Ik0yMSwxMEMyMSwxNyAxMiwyMyAxMiwyM0MxMiwyMyAzLDE3IDMsMTBDMyw1LjA2MyA3LjA2MywxIDEyLDFDMTYuOTM3LDEgMjEsNS4wNjMgMjEsMTBaIiBzdHlsZT0iZmlsbDpub25lO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpyZ2IoMjQ0LDMyLDg1KTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgPC9nPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwtMiwwKSI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMCIgcj0iMyIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6cmdiKDI0NCwzMiw4NSk7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgIDwvZz4KPC9zdmc+Cg==);
    margin-top: -5px;
    width: 23px;
}
.item-list li::after {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDggMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDsiPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwtOCwtNSkiPgogICAgICAgIDxwYXRoIGQ9Ik05LDE4TDE1LDEyTDksNiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDkwLDEwMSwxMjEpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=);
    position: relative;
    width: 6px;
    margin-top: 6px;
    margin-left: 10px;
    float: right;
}
.item-list li.not-verified::after {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDggMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDsiPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwtOCwtNSkiPgogICAgICAgIDxwYXRoIGQ9Ik05LDE4TDE1LDEyTDksNiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDI0NCwzMiw4NSk7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgIDwvZz4KPC9zdmc+Cg==);
}
.item-list li.verified::after {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDggMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDsiPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwtOCwtNSkiPgogICAgICAgIDxwYXRoIGQ9Ik05LDE4TDE1LDEyTDksNiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDMxLDE4MCwxODMpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=);
}
.item-list li:first-of-type::after {
    margin-top: 1px;
}

.error-list {
    font-size: 14px;
    color: #F42055;
    padding-left: 15px;
}
.kyc-fail-state {
    color: #49546a;
    display: block;
}
.kyc-fail-state p::after {
    position: relative;
    display: inline-block;
    width: 6px;
    margin-top: 2px;
    margin-left: 10px;
}
.kyc-fail-state p::after {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDggMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDsiPgogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwtOCwtNSkiPgogICAgICAgIDxwYXRoIGQ9Ik05LDE4TDE1LDEyTDksNiIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDI0NCwzMiw4NSk7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgIDwvZz4KPC9zdmc+Cg==);
}
.kyc-fail-state.animation-underline::after {
    background: #F42055;
    position: relative;
    margin: 0 auto;
    margin-top: 5px;
}
.kyc-fail-state.animation-underline:hover::after {
    width: 50%;
}
.kyc-status-overview img {
    width: 25px;
    margin: 0 auto;
    display: block;
    margin-bottom: 10px;
}

/* ==========================================================================
	Pill display
========================================================================== */

.pill-display {
    text-align: center;
}
.pill-display span.item {
    background-color: #dbe3f0;
    padding: 5px 20px;
    border-radius: 25px;
}
.pill-display span.item::before {
    position: relative;
    display: inline-block;
    width: 25px;
    margin-right: 10px;
    margin-top: -5px;
    transform: translate(0px, 3px);
}
.pill-display span.item::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIyIDIyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTEsLTEpIj4KICAgICAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6cmdiKDg5LDEwMCwxMjApO3N0cm9rZS1vcGFjaXR5OjAuNzU7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgICAgICA8cGF0aCBkPSJNMTIsNkwxMiwxMkwxNiwxNCIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDg5LDEwMCwxMjApO3N0cm9rZS1vcGFjaXR5OjAuNzU7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgIDwvZz4KPC9zdmc+Cg==);
    width: 18px;
}
.pill-display span.item.identity::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDE4IDIwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTMsLTIpIj4KICAgICAgICA8cGF0aCBkPSJNMjAsMjFMMjAsMTlDMjAsMTYuODA2IDE4LjE5NCwxNSAxNiwxNUw4LDE1QzUuODA2LDE1IDQsMTYuODA2IDQsMTlMNCwyMSIgc3R5bGU9ImZpbGw6bm9uZTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDczLDg0LDEwNik7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgICAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjciIHI9IjQiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOnJnYig3Myw4NCwxMDYpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=);
    width: 15px;
}
.pill-display span.item.verified::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIyIDIyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTEsLTAuOTk0MjgyKSI+CiAgICAgICAgPHBhdGggZD0iTTIyLDExLjA4TDIyLDEyQzIxLjk5NywxNy40ODQgMTcuNDg0LDIxLjk5NCAxMiwyMS45OTRDNi41MTQsMjEuOTk0IDIsMTcuNDggMiwxMS45OTRDMiw2LjUwOCA2LjUxNCwxLjk5NCAxMiwxLjk5NEMxMy40MDIsMS45OTQgMTQuNzg5LDIuMjg5IDE2LjA3LDIuODYiIHN0eWxlPSJmaWxsOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOnJnYigzMSwxODAsMTgzKTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgICAgIDxwYXRoIGQ9Ik0yMiw0TDEyLDE0LjAxTDksMTEuMDEiIHN0eWxlPSJmaWxsOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOnJnYigzMSwxODAsMTgzKTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgPC9nPgo8L3N2Zz4K);
    width: 21px;
    transform: translate(0px, 5px);
}
.pill-display span.item.not-verified::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIyIDIyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTEsLTEpIj4KICAgICAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6cmdiKDI0NCwzMiw4NSk7c3Ryb2tlLXdpZHRoOjJweDsiLz4KICAgICAgICA8cGF0aCBkPSJNMTUsOUw5LDE1IiBzdHlsZT0iZmlsbDpub25lO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpyZ2IoMjQ0LDMyLDg1KTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgICAgIDxwYXRoIGQ9Ik05LDlMMTUsMTUiIHN0eWxlPSJmaWxsOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOnJnYigyNDQsMzIsODUpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=);
    width: 21px;
    transform: translate(0px, 5px);
}
.pill-display span.item.address::before {
    content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIwIDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTIsMCkiPgogICAgICAgIDxwYXRoIGQ9Ik0yMSwxMEMyMSwxNyAxMiwyMyAxMiwyM0MxMiwyMyAzLDE3IDMsMTBDMyw1LjA2MyA3LjA2MywxIDEyLDFDMTYuOTM3LDEgMjEsNS4wNjMgMjEsMTBaIiBzdHlsZT0iZmlsbDpub25lO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpyZ2IoNzMsODQsMTA2KTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgICAgIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTAiIHI9IjMiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOnJnYig3Myw4NCwxMDYpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=);
    width: 15px;
}

/* Verified */

.pill-display span.item.verified {
    background-color: transparent;
    padding: 5px 20px;
    border-radius: 25px;
    border: 2px solid #1fb4b7;
    color: #1fb4b7;
}

/* Not verified */

.pill-display span.item.not-verified {
    background-color: transparent;
    padding: 5px 20px;
    border-radius: 25px;
    border: 2px solid #F42055;
    color: #F42055;
}

.input-currency-selector {
    position: absolute;
    width: 100px;
    margin-top: 13px;
    right: 37px;
    border: 2px solid #ffffff;
    border-left: 2px solid #ced9e3;
    border-radius: 0 50px 50px 0;
    padding: 5px 20px;
    padding-left: 0px;
    color: rgba(73, 84, 106, 0.75);
    transition: color 0.3s ease, border 0.3s ease;
    padding-left: 15px;
}
.input-currency-selector:hover,
.input-currency-selector:focus {
    border: 2px solid #ffffff;
    border-left: 2px solid #22cabe;
    color: #1fb4b7;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEwIDciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoyOyI+CiAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwxLC0wLjAxLC0wLjAwOSkiPgogICAgICAgIDxnIGlkPSJEb3duX2Fycm93IiB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwxLC0zNzg1LjYyLC04NTcuNzUpIj4KICAgICAgICAgICAgPHBhdGggZD0iTTM3OTAuNSw4NjQuMjU5TDM3ODUuNjMsODU3Ljc1OUwzNzk1LjM4LDg1Ny43NTlMMzc5MC41LDg2NC4yNTlaIiBzdHlsZT0iZmlsbDpyZ2IoMzEsMTgwLDE4Myk7Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K);
    transition: color 0.2s ease, border 0.2s ease;
}

#send-amount-input {
    text-align: right;
    padding-right: 120px;
}

#deposit-amount .input-currency-selector {
    margin-top: 18px;
    background-color: transparent;
    background-image: none;
    border: 2px solid transparent;
    border-left: 2px solid #ced9e3;
    padding-left: 7px;
    width: 74px;
    color: rgba(73, 84, 106, 0.75);
    padding-right: 0;
}
#deposit-amount .input-currency-selector:hover {
    border: 2px solid transparent;
    border-left: 2px solid #ced9e3;
    color: #49546a;
    cursor: default;
    color: rgba(73, 84, 106, 0.75);
}
#deposit-amount-input {
    text-align: right;
    padding-right: 85px;
}

/* ==========================================================================
	Sticky menu
========================================================================== */

.floating-header.active {
    position: sticky;
    display: block;
    z-index: 99;
    width: 430px;
    background: rgba(237, 240, 247, 0.95);
    box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.008),
    0 6.7px 5.3px rgba(0, 0, 0, 0.012),
    0 12.5px 10px rgba(0, 0, 0, 0.015),
    0 22.3px 17.9px rgba(0, 0, 0, 0.036),
    0 41.8px 33.4px rgba(0, 0, 0, 0.0215),
    0 100px 80px rgba(0, 0, 0, 0.03);
    top: -35px;
    margin-left: -35px;
    margin-top: -35px;
    padding-top: 25px;
    padding-bottom: 15px;
    padding-left: 35px;
    padding-right: 35px;
    border-radius: 40px 40px 0 0;
}

/* Home */

.home .floating-header.active h2 {
    font-size: 30px;
}
.home .floating-header.active .button {
    padding: 7px 20px;
}
.home .floating-header.active .button.outline {
    padding: 3px 20px;
}
.home .floating-header.active {
    padding-top: 25px;
    padding-bottom: 1px;
}

/* ==========================================================================
	Loading animation
========================================================================== */

.loading-animation {
    color: #bac3d9;
    text-align: center;
}

.loading-animation label {
    font-size: 20px;
    opacity: 0;
    display:inline-block;
}

@keyframes loading-animation {
    0% {
        opacity: 0;
        transform: translateX(-300px);
    }
    33% {
        opacity: 1;
        transform: translateX(0px);
    }
    66% {
        opacity: 1;
        transform: translateX(0px);
    }
    100% {
        opacity: 0;
        transform: translateX(300px);
    }
}
@-webkit-keyframes loading-animation {
    0% {
        opacity: 0;
        -webkit-transform: translateX(-300px);
    }
    33% {
        opacity: 1;
        -webkit-transform: translateX(0px);
    }
    66% {
        opacity: 1;
        -webkit-transform: translateX(0px);
    }
    100% {
        opacity: 0;
        -webkit-transform: translateX(300px);
    }
}

.loading-animation label:nth-child(6) {
	-webkit-animation: loading-animation 3s infinite ease-in-out;
	animation: loading-animation 3s infinite ease-in-out;
}
.loading-animation label:nth-child(5) {
	-webkit-animation: loading-animation 3s 100ms infinite ease-in-out;
	animation: loading-animation 3s 100ms infinite ease-in-out;
}
.loading-animation label:nth-child(4) {
	-webkit-animation: loading-animation 3s 200ms infinite ease-in-out;
	animation: loading-animation 3s 200ms infinite ease-in-out;
}
.loading-animation label:nth-child(3) {
	-webkit-animation: loading-animation 3s 300ms infinite ease-in-out;
	animation: loading-animation 3s 300ms infinite ease-in-out;
}
.loading-animation label:nth-child(2) {
	-webkit-animation: loading-animation 3s 400ms infinite ease-in-out;
	animation: loading-animation 3s 400ms infinite ease-in-out;
}
.loading-animation label:nth-child(1) {
	-webkit-animation: loading-animation 3s 500ms infinite ease-in-out;
	animation: loading-animation 3s 500ms infinite ease-in-out;
}

/* ==========================================================================
	Landing page (Specific styles)
========================================================================== */

.landing-page header .logo {
	margin: 0;
	width: 115px;
}
.landing-page p {
	font-size: 18px;
	line-height: 1.8;
}
.hero-image {
	width: 100%;
	height: 1000px;
	position: absolute;
	top: 0;
	left: 0;
	background-image: url(data:image/png;base64,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);
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center top;
	z-index: -9;
}

/* ==========================================================================
	Home (Specific styles)
========================================================================== */

.home h2 {
	font-size: 40px;
}
.home .account {
	margin-bottom: 15px;
}
.home .account a::after {
	content: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEwIDciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoyOyI+CiAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwxLC0wLjAxLC0wLjAwOSkiPgogICAgICAgIDxnIGlkPSJEb3duX2Fycm93IiB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwxLC0zNzg1LjYyLC04NTcuNzUpIj4KICAgICAgICAgICAgPHBhdGggZD0iTTM3OTAuNSw4NjQuMjU5TDM3ODUuNjMsODU3Ljc1OUwzNzk1LjM4LDg1Ny43NTlMMzc5MC41LDg2NC4yNTlaIiBzdHlsZT0iZmlsbDpyZ2IoMzEsMTgwLDE4Myk7Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K);
	position: relative;
	display: inline-block;
	width: 10px;
	cursor: pointer;
	margin-top: -1px;
	margin-left: 5px;
}

/* ==========================================================================
	View blockchain address (Specific styles)
========================================================================== */

#view-address img {
    display: block;
    width: 50%;
    margin: 0 auto;
}

/* ==========================================================================
	Sign in expired (Specific styles)
========================================================================== */

#signing-you-in .feature-icon {
	max-width: 65px;
}

/* ==========================================================================
	Sign in expired (Specific styles)
========================================================================== */

#sign-in-expired .feature-icon {
	max-width: 75px;
}

/* ==========================================================================
	Sign in successful (Specific styles)
========================================================================== */

#sign-in-successfull .feature-icon {
	max-width: 65px;
}

/* ==========================================================================
	Deposit (Specific styles)
========================================================================== */

.deposit-type-option {
    display: block;
    border-radius: 20px;
    padding: 20px 5px;
    color: #49546a;
    transition: background-color ease 0.3s, color ease 0.3s;
}
.deposit-type-option:hover {
    background-color: #dbe3f0;
    color: #1fb4b7;
    transition: background-color ease 0.2s, color ease 0.2s;
}
.deposit-type-option .feature-icon {
    height: 55px;
}

/* ==========================================================================
	Transaction (Specific styles)
========================================================================== */

.transaction h2 {
	font-size: 50px;
}

/* ==========================================================================
	KYC (Specific styles)
========================================================================== */

#kyc-intro img,
#kyc-successful img {
    max-width: 70px;
}

/* ==========================================================================
	Error (Specific styles)
========================================================================== */

#error img {
	max-width: 90px;
	padding-left: 15px;
}

/* ==========================================================================
	Change email
========================================================================== */

.change-email-verify img.feature-icon {
	max-width: 50px;
}

/* ==========================================================================
	Third party fixes
========================================================================== */

/* KYC agreement */

.account-agreement-container {
	max-width: 100%;
	overflow-x: hidden;
}
.account-agreement-container .BasicParagraph p {
	text-align: left;
}
.account-agreement-container .BasicParagraph b {
	font-family: montserrat-regular;
	font-weight: normal;
}
.account-agreement-container .FormCopy span {
	font-family: montserrat-regular;
	font-weight: normal;
}

/* ==========================================================================
	Modal
========================================================================== */

.modal-overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    visibility: hidden;
    top: 0;
    left: 0;
    z-index: 1000;
    opacity: 0;
    background: -webkit-linear-gradient( 135deg, rgba(213,221,241, 0.75) 0%, rgba(241,244,249, 0.75) 100%);
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
}
.modal {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 50%;
    height: auto;
    z-index: 2000;
    max-width: 430px;
    visibility: hidden;
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
}

/* Modal content */

.modal-content {
	position: relative;
	margin: 0 auto;
}

/* Modal visible */

.modal-show {
	visibility: visible;
}
.modal-show ~ .modal-overlay {
	opacity: 1;
	visibility: visible;
}

/* Modal animation */

.modal .modal-content {
	-webkit-transform: scale(0.7);
	-moz-transform: scale(0.7);
	-ms-transform: scale(0.7);
	transform: scale(0.7);
	opacity: 0;
	-webkit-transition: all 0.3s;
	-moz-transition: all 0.3s;
	transition: all 0.3s;
}
.modal-show .modal-content {
	-webkit-transform: scale(1);
	-moz-transform: scale(1);
	-ms-transform: scale(1);
	transform: scale(1);
	opacity: 1;
}

/* ==========================================================================
	Notification
========================================================================== */

/* New */

.notification {
    position: absolute;
    left: 35px;
    right: 35px;
    background: rgba(237, 240, 247, 0.95);
    border: 3px solid rgba(73, 84, 106, 0.50);
    padding: 22px;
    border-radius: 20px;
    line-height: 1.4;
    z-index: 1000;
    box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.017), 0 6.7px 5.3px rgba(0, 0, 0, 0.024), 0 12.5px 10px rgba(0, 0, 0, 0.03), 0 22.3px 17.9px rgba(0, 0, 0, 0.036), 0 41.8px 33.4px rgba(0, 0, 0, 0.043), 0 100px 80px rgba(0, 0, 0, 0.06);
}
.notification.success {
	border: 3px solid #00d1c1;
}
.notification.error {
	border: 3px solid #F42055;
}

/* Notification close button */

.notification-close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 18px;
    top: 23px;
    overflow: hidden;
    text-indent: 100%;
    cursor: pointer;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}
.notification-close:hover,
.notification-close:focus {
	outline: none;
}
.notification-close::before,
.notification-close::after {
	content: '';
	position: absolute;
	width: 3px;
	height: 60%;
	top: 50%;
	left: 50%;
	background: #6e6e6e;
}
.notification-close:hover::before,
.notification-close:hover::after {
	background: #fff;
}
.notification-close::before {
	-webkit-transform: translate(-50%,-50%) rotate(45deg);
	transform: translate(-50%,-50%) rotate(45deg);
}
.notification-close::after {
	-webkit-transform: translate(-50%,-50%) rotate(-45deg);
	transform: translate(-50%,-50%) rotate(-45deg);
}

/* ==========================================================================
	Notification (Demo of how it should work)
========================================================================== */

/* Default */

.ns-box {
    position: sticky;
    background: rgba(237, 240, 247, 0.95);
    border: 3px solid #00d1c1;
    padding: 22px;
    border-radius: 20px;
    line-height: 1.4;
    z-index: 1000;
    pointer-events: none;
    box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.017), 0 6.7px 5.3px rgba(0, 0, 0, 0.024), 0 12.5px 10px rgba(0, 0, 0, 0.03), 0 22.3px 17.9px rgba(0, 0, 0, 0.036), 0 41.8px 33.4px rgba(0, 0, 0, 0.043), 0 100px 80px rgba(0, 0, 0, 0.06);
}

.ns-box.ns-show,
.ns-box.ns-visible {
	pointer-events: auto;
}

/* Notification close button */

.ns-close {
	width: 20px;
	height: 20px;
	position: absolute;
	right: 4px;
	top: 4px;
	overflow: hidden;
	text-indent: 100%;
	cursor: pointer;
	-webkit-backface-visibility: hidden;
	backface-visibility: hidden;
}
.ns-close:hover,
.ns-close:focus {
	outline: none;
}
.ns-close::before,
.ns-close::after {
	content: '';
	position: absolute;
	width: 3px;
	height: 60%;
	top: 50%;
	left: 50%;
	background: #6e6e6e;
}
.ns-close:hover::before,
.ns-close:hover::after {
	background: #fff;
}
.ns-close::before {
	-webkit-transform: translate(-50%,-50%) rotate(45deg);
	transform: translate(-50%,-50%) rotate(45deg);
}
.ns-close::after {
	-webkit-transform: translate(-50%,-50%) rotate(-45deg);
	transform: translate(-50%,-50%) rotate(-45deg);
}

/* Specifc styles */

.ns-box.ns-bar {
	top: 0;
	left: 0;
	width: 100%;
}
.ns-bar .ns-close {
	background: transparent;
	top: 50%;
	right: 20px;
	-webkit-transform: translateY(-50%);
	transform: translateY(-50%);
}

.ns-bar .ns-close::before,
.ns-bar .ns-close::after {
	background: #b7b5b3;
}

[class^="ns-effect-"].ns-bar.ns-hide,
[class*=" ns-effect-"].ns-bar.ns-hide {
	-webkit-animation-direction: reverse;
	animation-direction: reverse;
}

/* Individual Effects */

.ns-effect-slidetop .icon {
	background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDIzIDIxIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zOnNlcmlmPSJodHRwOi8vd3d3LnNlcmlmLmNvbS8iIHN0eWxlPSJmaWxsLXJ1bGU6ZXZlbm9kZDtjbGlwLXJ1bGU6ZXZlbm9kZDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7Ij4KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTEuOWUtMDUsMC4wMDAyNikiPgogICAgICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTAuNTUxOTgxLC0xLjg5NzI2KSI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMC4yOSwzLjg2TDEuODIsMThDMS42NDQsMTguMzA0IDEuNTUyLDE4LjY0OSAxLjU1MiwxOUMxLjU1MiwyMC4wODkgMi40NDEsMjAuOTg4IDMuNTMsMjFMMjAuNDcsMjFDMjEuNTU5LDIwLjk4OCAyMi40NDgsMjAuMDg5IDIyLjQ0OCwxOUMyMi40NDgsMTguNjQ5IDIyLjM1NiwxOC4zMDQgMjIuMTgsMThMMTMuNzEsMy44NkMxMy4zNDgsMy4yNjMgMTIuNjk4LDIuODk3IDEyLDIuODk3QzExLjMwMiwyLjg5NyAxMC42NTIsMy4yNjMgMTAuMjksMy44NloiIHN0eWxlPSJmaWxsOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOnJnYigyNDQsMzIsODUpO3N0cm9rZS13aWR0aDoycHg7Ii8+CiAgICAgICAgPC9nPgogICAgICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsMCwwLDEsLTAuNTUxOTgxLC0xLjg5NzI2KSI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMiw5TDEyLDEzIiBzdHlsZT0iZmlsbDpub25lO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpyZ2IoMjQ0LDMyLDg1KTtzdHJva2Utd2lkdGg6MnB4OyIvPgogICAgICAgIDwvZz4KICAgICAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwxLC0wLjU1MTk4MSwtMS44OTcyNikiPgogICAgICAgICAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwxLC0xLDApIj4KICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjEzIiBjeT0iMTciIHI9IjEiIHN0eWxlPSJmaWxsOnJnYigyNDQsMzIsODUpOyIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K);
	position: absolute;
	display: block;
	width: 25px;
	height: 20px;
	background-repeat: no-repeat;
	top: 25px;
	left: 36px;
}
.ns-effect-slidetop p {
	padding: 0 3.2em;
	display: inline-block;
}

/* Animation */

.ns-effect-slidetop .ns-close::before,
.ns-effect-slidetop .ns-close::after {
	width: 2px;
	background: #1fb4b7;
	transition: background ease 0.3s;
}

.ns-effect-slidetop .ns-close:hover::before,
.ns-effect-slidetop .ns-close:hover::after {
	background: #49546a;
	transition: background ease 0.2s;
}

/* Error */

.ns-box {
	border: 3px solid #F42055;
	color: #F42055;
}
.ns-effect-slidetop .ns-close::before,
.ns-effect-slidetop .ns-close::after {
	width: 2px;
	background: #F42055;
}

.ns-effect-slidetop .ns-close:hover::before,
.ns-effect-slidetop .ns-close:hover::after {
	background: #F42055;
}



.ns-effect-slidetop.ns-show .icon,
.ns-effect-slidetop.ns-show p {
	-webkit-animation-name: animScaleUp;
	animation-name: animScaleUp;
	-webkit-animation-duration: 0.3s;
	animation-duration: 0.3s;
	-webkit-animation-delay: 0.2s;
	animation-delay: 0.2s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
	top: 32px;
}

.ns-effect-slidetop.ns-show p {
	-webkit-animation-name: animFade;
	animation-name: animFade;
}

@-webkit-keyframes animScaleUp {
	0% { opacity: 0; -webkit-transform: translate3d(0,-50%,0) scale3d(0,0,1); }
	100% { opacity: 1; -webkit-transform: translate3d(0,-50%,0) scale3d(1,1,1); }
}

@keyframes animScaleUp {
	0% { opacity: 0; -webkit-transform: translate3d(0,-50%,0) scale3d(0,0,1); transform: translate3d(0,-50%,0) scale3d(0,0,1); }
	100% { opacity: 1; -webkit-transform: translate3d(0,-50%,0) scale3d(1,1,1); transform: translate3d(0,-50%,0) scale3d(1,1,1); }
}

.ns-effect-slidetop.ns-show,
.ns-effect-slidetop.ns-hide {
	-webkit-animation-name: animSlideTop;
	animation-name: animSlideTop;
	-webkit-animation-duration: 0.3s;
	animation-duration: 0.3s;
}

@-webkit-keyframes animSlideTop {
	0% { -webkit-transform: translate3d(0,-100%,0); }
	100% { -webkit-transform: translate3d(0,0,0); }
}

@keyframes animSlideTop {
	0% { -webkit-transform: translate3d(0,-100%,0); transform: translate3d(0,-100%,0); }
	100% { -webkit-transform: translate3d(0,0,0); transform: translate3d(0,0,0); }
}

/* Expanding Loader */
.ns-effect-exploader {
	background: #fff;
	color: #7a7264;
	-webkit-transform-origin: 0 0;
	transform-origin: 0 0;
}

.ns-effect-exploader .icon {
	position: absolute;
	left: 0.25em;
	top: 50%;
	-webkit-transform: translate3d(0,-50%,0);
	transform: translate3d(0,-50%,0);
}

.ns-effect-exploader .ns-box-inner {
	position: relative;
}

.ns-effect-exploader p {
	padding: 0.25em 2em 0.25em 3em;
}

.ns-effect-exploader .ns-close:hover::before,
.ns-effect-exploader .ns-close:hover::after {
	background: #98815a;
}

.ns-effect-exploader.ns-show {
	-webkit-animation-name: animLoad;
	animation-name: animLoad;
	-webkit-animation-duration: 2.5s;
	animation-duration: 2.5s;
}

@-webkit-keyframes animLoad {
	0% { opacity: 1; -webkit-transform: scale3d(0,0.3,1); }
	33% { opacity: 1; -webkit-transform: scale3d(0.5,0.3,1); }
	50% { opacity: 1; -webkit-transform: scale3d(0.6,0.3,1); }
	80%, 85% { opacity: 1; -webkit-transform: scale3d(1,0.3,1); -webkit-animation-timing-function: cubic-bezier(0.7,0,0.3,1); }
	100% { opacity: 1; -webkit-transform: scale3d(1,1,1); }
}

@keyframes animLoad {
	0% { opacity: 1; -webkit-transform: scale3d(0,0.3,1); transform: scale3d(0,0.3,1); }
	33% { opacity: 1; -webkit-transform: scale3d(0.5,0.3,1); transform: scale3d(0.5,0.3,1); }
	50% { opacity: 1; -webkit-transform: scale3d(0.6,0.3,1); transform: scale3d(0.6,0.3,1); }
	80%, 85% { opacity: 1; -webkit-transform: scale3d(1,0.3,1); transform: scale3d(1,0.3,1); -webkit-animation-timing-function: cubic-bezier(0.7,0,0.3,1); animation-timing-function: cubic-bezier(0.7,0,0.3,1); }
	100% { opacity: 1; -webkit-transform: scale3d(1,1,1); transform: scale3d(1,1,1); }
}

.ns-effect-exploader.ns-hide {
	-webkit-animation-name: animFade;
	animation-name: animFade;
	-webkit-animation-duration: 0.3s;
	animation-duration: 0.3s;
}

.ns-effect-exploader.ns-show .ns-box-inner,
.ns-effect-exploader.ns-show .ns-close {
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
	-webkit-animation-duration: 0.3s;
	animation-duration: 0.3s;
	-webkit-animation-delay: 2.4s;
	animation-delay: 2.4s;
}

.ns-effect-exploader.ns-show .ns-close {
	-webkit-animation-name: animFade;
	animation-name: animFade;
}

.ns-effect-exploader.ns-show .ns-box-inner {
	-webkit-animation-name: animFadeMove;
	animation-name: animFadeMove;
	-webkit-animation-timing-function: ease-out;
	animation-timing-function: ease-out;
}

@-webkit-keyframes animFadeMove {
	0% { opacity: 0; -webkit-transform: translate3d(0,10px,0); }
	100% { opacity: 1; -webkit-transform: translate3d(0,0,0); }
}

@keyframes animFadeMove {
	0% { opacity: 0; -webkit-transform: translate3d(0,10px,0); transform: translate3d(0,10px,0); }
	100% { opacity: 1; -webkit-transform: translate3d(0,0,0); transform: translate3d(0,0,0); }
}

@-webkit-keyframes animFade {
	0% { opacity: 0; }
	100% { opacity: 1; }
}

@keyframes animFade {
	0% { opacity: 0; }
	100% { opacity: 1; }
}

/* ==========================================================================
	Repsonsive styles
========================================================================== */

/*
*
* Responsive styles - 800px & smaller
*
*/

@media (max-width: 800px) {

	.modal {
		width: 100%;
	}

}


/* ==========================================================================
	Third party overwrites
========================================================================== */

/* ==========================================================================
	Account agreement (Third party overwrite)
========================================================================== */

.account-agreement-container {
	overflow-x: hidden;
	max-height: 210px;
	border-radius: 20px;
	border: 2px solid #C8D1E1;
	margin-bottom: 15px;
	margin-top: 15px;
	padding: 25px;
	padding-top: 15px;
	padding-bottom: 15px;
}
.account-agreement-container p,
.account-agreement-container b,
.account-agreement-container span {
	font-family: montserrat-regular !important;
	font-weight: normal;
	text-align: left !important;
	color: #49546a !important;
}
.account-agreement-container p b span {
	font-size: 20px !important;
}
.pt__signature h1 {
	font-size: 20px;
	font-weight: normal;
}
#kyc-agreement p.label-small.text-center {
	margin-top: 10px;
}
#account-terms-checkbox {
	margin-right: 15px;
}

/* ==========================================================================
	Add credit or debit card (Third party overwrite)
========================================================================== */

#root, body {
	background-color: transparent !important;
}
#root div div {
	padding: 0 !important;
	margin: 0 !important;
}
#root .ant-btn-block {
    border-radius: 100px;
    padding: 10px 30px;
    min-width: 150px;
    text-align: center;
    outline: none;
    border: none;
    height: initial;
    color: #ffffff;
    background-size: 1px 200px;
    box-shadow: 0 2.8px 2.2px rgba(30, 128, 177, 0.017), 0 6.7px 5.3px rgba(30, 128, 177, 0.024), 0 12.5px 10px rgba(30, 128, 177, 0.03), 0 22.3px 17.9px rgba(30, 128, 177, 0.036), 0 41.8px 33.4px rgba(30, 128, 177, 0.043), 0 100px 80px rgba(30, 128, 177, 0.06) !important;
    background-image: -moz-linear-gradient( -135deg, rgb(34,215,194) 0%, rgb(30,158,177) 100%);
    background-image: -webkit-linear-gradient( -135deg, rgb(34,215,194) 0%, rgb(30,158,177) 100%);
    background-image: -ms-linear-gradient( -135deg, rgb(34,215,194) 0%, rgb(30,158,177) 100%);
    transition: box-shadow 0.3s ease, background-position 0.3s ease;
    cursor: pointer !important;
    margin-top: 25px;
    width: 50%;
    left: 25%;
    text-transform: initial;
}
#root .ant-btn-block:hover {
    color: #ffffff !important;
    background-image: -moz-linear-gradient( -135deg, rgb(34,215,194) 0%, rgb(30,158,177) 100%);
    background-image: -webkit-linear-gradient( -135deg, rgb(34,215,194) 0%, rgb(30,158,177) 100%);
    background-image: -ms-linear-gradient( -135deg, rgb(34,215,194) 0%, rgb(30,158,177) 100%);
    box-shadow: 0 2.8px 2.2px rgba(30, 128, 177, 0.034), 0 6.7px 5.3px rgba(30, 128, 177, 0.048), 0 12.5px 10px rgba(30, 128, 177, 0.06), 0 22.3px 17.9px rgba(30, 128, 177, 0.072), 0 41.8px 33.4px rgba(30, 128, 177, 0.086), 0 100px 80px rgba(30, 128, 177, 0.12) !important;
    background-position: 0px !important;
    transition: box-shadow 0.2s ease, background-position 0.2s ease;
}
#root .ant-spin-container {
	margin-bottom: 15px
}
#root .ant-input,
#root .ant-select-selection,
#root .ant-input-number-input {
    border: 2px solid #ced9e3 !important;
    border-radius: 10px;
    padding: 8px 20px;
    color: #49546a;
    outline: none;
    transition: border 0.2s ease;
    width: 100%;
}
#root #pending_country .ant-select-selection {
	width: 100%;
}
#root .ant-input:focus,
#root .ant-input:hover,
#root .ant-input-number-input:focus,
#root .ant-input-number-input:hover {
	border: 2px solid #22cabe !important;
	box-shadow: none !important;
	transition: border 0.2s ease;
}
#box-shadow {
	box-shadow: none;
}
#root .ant-input-affix-wrapper .ant-input-prefix {
	display: none;
}
#root .ant-typography h3,
#root h3.ant-typography {
	margin-top: 15px;
	margin-bottom: 0;
	font-weight: normal;
	color: #49546a !important;
	display: none;
}
#root .ant-form-item-label > label {
	color: #49546a;
}
#root #pending_cvv {
	width: 83% !important;
	margin-left: 25px;
}
#root label[for=pending_cvv] {
	margin-left: 25px;
}
#root #ant-row {
	margin-left: 0;
	margin-right: 0;
}
#root .ant-alert-icon {
	display: none !important;
}
#root div div.ant-spin-container {
	padding-bottom: 50px !important;
}
#root div div .ant-alert-info {
	padding: 25px !important;
	margin-top: 15px !important;
	border-radius: 20px;
	display: none;
}
#root .ant-form label {
	margin-top: 25px;
	display: block;
	margin-bottom: 10px;
}
#root .widget {
	min-height: initial;
}
#root .modal {
	padding: 0;
}
#root #pending_region,
#root #pending_postalCode {
	width: 92%;
}
#root #pending_street2,
#root label[for=pending_street2] {
	display: none;
}
#root .pt-mpf-sidebar.pt-mpf-sidebar-hidden {
	display: none;
}
#root #pending_region,
#root #pending_postalCode {
	width: 92% !important;
}
#root #pending_postalCode,
#root label[for=pending_postalCode] {
	margin-left: 8%;
}
#root label[for=pending_name],
#root label[for=pending_number],
#root label[for=pending_expirationDate],
#root label[for=pending_cvv],
#root label[for=pending_country],
#root label[for=pending_street1],
#root label[for=pending_city],
#root label[for=pending_region],
#root label[for=pending_postalCode],
#root label[for=authorized_descriptor],
#root label[for=authorized_amount] {
	font-size: 0;
}
#root label[for=pending_name]::before {
	content: "Use a debit card to avoid a cash advance fee from your bank.";
	color: inherit;
	display: inline-block;
	font-size: 15px;
	background-color: #e6f7ff;
	border: 1px solid #91d5ff;
	padding: 15px;
	border-radius: 20px;
	margin-right: 0;
	margin-bottom: 25px;
	line-height: 1.5;
}
#root label[for=pending_name]::after {
	content: "Name on card";
	color: inherit;
	font-size: 15px;
	display: inline-block;
}
#root label[for=pending_number]::before {
	content: "Card number";
	color: inherit;
}
#root label[for=pending_expirationDate]::before {
	content: "Expiry date";
	color: inherit;
}
#root label[for=pending_cvv]::before {
	content: "Security code";
	color: inherit;
}
#root label[for=pending_country]::before {
	content: "Country";
	color: inherit;
}
#root label[for=pending_street1]::before {
	content: "Street";
	color: inherit;
}
#root label[for=pending_city]::before {
	content: "Town/city";
	color: inherit;
}
#root label[for=pending_region]::before {
	content: "Region";
	color: inherit;
}
#root label[for=pending_postalCode]::before {
	content: "Postcode";
	color: inherit;
}
#root label[for=authorized_descriptor]::before {
	content: "Retrieve your card’s transaction history and find the temporary charge from PRM.";
	color: inherit;
	display: inline-block;
	font-size: 15px;
	background-color: #e6f7ff;
	border: 1px solid #91d5ff;
	padding: 15px;
	border-radius: 20px;
	margin-right: 0;
	margin-bottom: 25px;
	line-height: 1.5;
}
#root label[for=authorized_descriptor]::after {
	content: "Enter the 4-digit code:";
	color: inherit;
	display: inline-block;
	font-size: 15px;
}
#root label[for=authorized_amount]::before {
	content: "Retrieve your card’s transaction history and find the temporary charge from PRM.";
	color: inherit;
	display: inline-block;
	font-size: 15px;
	background-color: #e6f7ff;
	border: 1px solid #91d5ff;
	padding: 15px;
	border-radius: 20px;
	margin-right: 0;
	margin-bottom: 25px;
	line-height: 1.5;
}
#root label[for=authorized_amount]::after {
	content: "Amount in dollars:";
	color: inherit;
	display: inline-block;
	font-size: 15px;
}
#root h3.ant-typography {
	font-size: 0 !important;
}
#root h3.ant-typography::before {
	content: "Card details";
	font-size: 25px;
}
#root .ant-form-item-required::before {
	font-size: 15px;
}
#root div div .ant-select-selection-selected-value {
	margin-right: 22px;
}
#root .styledButton-0-1-1 {
	text-transform: initial !important;
}
#root .ant-btn-link {
	color: #1fb4b7;
}
#root .ant-btn-link:hover {
	color: #1d8e91;
}
#root div div .ant-alert-success {
	background-color: transparent;
	border: none;
	text-align: center;
}
#root div div .ant-alert-success .ant-alert-message {
	font-size: 0px;
	color: #49546a;
	margin-top: 50px;
}
#root div div .ant-alert-success .ant-alert-message::before {
	font-size: 30px;
	content: "Card approved";
	color: inherit;
}
#root div div .ant-alert-success .ant-alert-description {
	color: #49546a;
	font-size: 0px;
}
#root div div .ant-alert-success .ant-alert-description::before {
	content: "You can now use your card to make payments.";
	color: inherit;
	font-size: 15px;
}
#root #pending_country .ant-select-selection {
	padding-left: 21px !important;
}
#root div div #pending_region .ant-select-selection--single {
	height: initial;
	padding: 3px 20px !important;
}
#root .ant-input-number {
	border: none;
}

/* ==========================================================================
	Add bank account (Third party overwrite)
========================================================================== */

.desktop .Overlay {
    background: -webkit-linear-gradient( 135deg, rgba(213,221,241, 0.75) 0%, rgba(241,244,249, 0.75) 100%);
}
.desktop .Overlay__content {
	border-radius: 20px;
	background-color: #f1f4f9;
	box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.017), 0 6.7px 5.3px rgba(0, 0, 0, 0.024), 0 12.5px 10px rgba(0, 0, 0, 0.03), 0 22.3px 17.9px rgba(0, 0, 0, 0.036), 0 41.8px 33.4px rgba(0, 0, 0, 0.043), 0 100px 80px rgba(0, 0, 0, 0.06);
}
.Overlay__content .Button--is-plaid-color {
    border-radius: 100px;
    height: initial;
    padding: 10px 30px;
    text-align: center;
    outline: none;
    border: none;
    color: #ffffff;
    background-size: 1px 200px;
    box-shadow: 0 2.8px 2.2px rgba(30, 128, 177, 0.017), 0 6.7px 5.3px rgba(30, 128, 177, 0.024), 0 12.5px 10px rgba(30, 128, 177, 0.03), 0 22.3px 17.9px rgba(30, 128, 177, 0.036), 0 41.8px 33.4px rgba(30, 128, 177, 0.043), 0 100px 80px rgba(30, 128, 177, 0.06);
    background-image: -moz-linear-gradient( -135deg, rgb(34,215,194) 0%, rgb(30,158,177) 100%);
    background-image: -webkit-linear-gradient( -135deg, rgb(34,215,194) 0%, rgb(30,158,177) 100%);
    background-image: -ms-linear-gradient( -135deg, rgb(34,215,194) 0%, rgb(30,158,177) 100%);
    transition: box-shadow 0.3s ease, background-position 0.3s ease;
    cursor: pointer !important;
    margin-top: 15px;
    font-size: 16px;
}
.Overlay__content .Button--is-plaid-color:hover {
	color: #ffffff;
	box-shadow: 0 2.8px 2.2px rgba(30, 128, 177, 0.034), 0 6.7px 5.3px rgba(30, 128, 177, 0.048), 0 12.5px 10px rgba(30, 128, 177, 0.06), 0 22.3px 17.9px rgba(30, 128, 177, 0.072), 0 41.8px 33.4px rgba(30, 128, 177, 0.086), 0 100px 80px rgba(30, 128, 177, 0.12);
	background-position: 50px;
	transition: box-shadow 0.2s ease, background-position 0.2s ease;
}
.mobile .Navbar--is-InstitutionSelectPane {
	background-color: #f1f4f9;
}
.Overlay__content .InstitutionSearchInput__input {
	border: 2px solid #ced9e3;
	border-radius: 100px;
}
.Overlay__content .InstitutionSearchInput__input:focus,
.Overlay__content .InstitutionSearchInput__input:active {
	border: 2px solid #22cabe;
}
.desktop .InstitutionSelectPaneButton {
	border: 2px solid rgba(0,0,0,0.05);
	border-radius: 5px;
}
.desktop .InstitutionSelectPaneButton:hover {
	border: 2px solid #22cabe;
}


/* ==========================================================================
	Widget responsive styles
========================================================================== */


/*
* 
* X.7 - Responsive styles - 1600px
*
*/

@media (min-width: 1600px) {
}

/*
* 
* X.7 - Responsive styles - 1600px
*
*/

@media (max-width: 1600px) {

	/* HTML */

	input {
		padding: 6px 15px;
	}

	/* Widget */

	.widget {
		max-width: 400px;
	}
	.widget .logo {
		width: 45px;
	}
	.widget h2 {
		font-size: 25px;
	}
	.widget .feature-icon {
		width: 55px;
	}

	/* Asset list */

	.assets-list td {
		font-size: 14px;
	}

	/* Transaction list */

	.transaction-list {
		font-size: 14px;
	}

	/* Widget (Specific) */

	#home h2 {
		font-size: 35px;
	}
	#sign-in-expired .feature-icon {
		max-width: 70px;
	}

}

/*
* 
* X.7 - Responsive styles - 1000px
*
*/

@media (max-width: 1200px) {
}

/*
* 
* X.7 - Responsive styles - 1000px
*
*/

@media (max-width: 1000px) {
}

/*
* 
* X.7 - Responsive styles - 800px
*
*/

@media (max-width: 800px) {
}

/*
* 
* X.7 - Responsive styles - 600px
*
*/

@media (max-width: 600px) {
}


/* ==========================================================================
	Custom CSS
========================================================================== */

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}

#bridge-button:hover {
    cursor: pointer;
}

.error-span {
    color: red;
    padding: 0;
    margin: -20px 0 0 0;
    font-size: 14px;
}

.red-error-text {
    color: red;
    font-size: 14px;
}

.border-red {
    border-color: red !important;
}

.blockchain-address {
    padding: 0;
    margin: 0;
    display: inline-block;
    max-width: 210px;
    overflow-wrap: break-word;
}


input[type="submit"] {
    text-decoration: none;
    cursor: pointer !important;
    line-height: 1.5 !important;
    display: inline-block !important;
    border-radius: 100px !important;
    padding: 10px 30px !important;
    min-width: 150px !important;
    text-align: center !important;
    color: #ffffff !important;
    background-size: 1px 200px !important;
    background-color: #2196F3; /* fallback */
}

.button.disable {
    border: 2px solid darkgrey;
    color: darkgrey;
    background-image: none;
    background-color: transparent;
    padding: 8px 30px;
    box-shadow: transparent;
    transition: color 0.3s ease, border 0.3s ease, background-color 0.3s ease;
    cursor: not-allowed !important;
}

.slider {
    /* complete liquid height based on the parent's height!! */
    max-height: 100px;

    /* only transition on transform properties which are hardware accelerated = way better performances */
    -webkit-transition:-webkit-transform .5s ease;
    -moz-transition:   -moz-transform .5s ease;
    -ms-transition:    -ms-transform .5s ease;
    transition:        transform .5s ease;
}

.slider.opened {
    /* visible */
    -webkit-transform: translate(0, 0%);
    -moz-transform: translate(0, 0%);
    -ms-transform: translate(0, 0%);
    transform: translate(0, 0%);
}
.slider.closed {
    /* completely offscreen */
    -webkit-transform: translate(0, -50%);
    -moz-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);
}
`;
    